import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-secondary-100 border-t border-secondary-200/70">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="font-heading text-xl font-bold text-primary-600 whitespace-nowrap cursor-pointer">
              韩漫屋
            </Link>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
              免费韩漫在线阅读平台，提供高清韩国漫画资源。下拉式阅读体验，海量韩漫每日更新，打造最舒适的漫画阅读环境。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-800 mb-4">
              <a href="#quick-links">快速链接</a>
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/category/recommend" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">
                  漫画分类
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-800 mb-4">
              <a href="#hot-categories">热门分类</a>
            </h4>
            <ul className="space-y-2">
              <li>
                <Link to="/category/romance" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">
                  恋爱韩漫
                </Link>
              </li>
              <li>
                <Link to="/category/fantasy" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">
                  奇幻韩漫
                </Link>
              </li>
              <li>
                <Link to="/category/action" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">
                  动作韩漫
                </Link>
              </li>
              <li>
                <Link to="/category/completed" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors cursor-pointer">
                  完结韩漫
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-foreground-800 mb-4">
              <a href="#contact">联系我们</a>
            </h4>
            <ul className="space-y-2 text-sm text-foreground-600">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-primary-500 text-sm w-4 h-4 flex items-center justify-center"></i>
                <span>contact@hanmanwu.com</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-customer-service-2-line text-primary-500 text-sm w-4 h-4 flex items-center justify-center"></i>
                <span>在线客服：工作日 9:00-18:00</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-secondary-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 韩漫屋 HanManWu. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors" rel="nofollow">
              隐私政策
            </a>
            <a href="#" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors" rel="nofollow">
              服务条款
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}